export const selectableColors: Array<ISelectableSheetColor> = [
	{ family: "svart", pluralName: "svarta", render: "black" },
	{ family: "grå", pluralName: 'gråa', render: "gray" },
	{ family: "vit", pluralName: "vita", render: "white" },
	{ family: "grön", pluralName: "gröna", render: "green" },
	{ family: "blå", pluralName: "blåa", render: "blue" },
	{ family: "gul", pluralName: "gula", render: "yellow" },
	{ family: "silver", pluralName: "silver", render: "linear-gradient(90deg, rgba(232,232,232,1) 0%, rgba(103,103,103,1) 100%)" },
	{ family: "röd", pluralName: "röda", render: "red" },
	{ family: "brun", pluralName: "bruna", render: "brown" },
	{ family: "guld", pluralName: "guld", render: "linear-gradient(90deg, rgba(255,204,1,1) 0%, rgba(169,108,0,1) 100%)" },
	{ family: "brons", pluralName: "brons", render: "linear-gradient(90deg, rgba(131,80,1,1) 0%, rgba(216,142,3,1) 100%)" },
	{ family: "biege", pluralName: "biega", render: "beige" }
];

